import { Box, IconButton } from '@mui/material'
import { styled } from '@mui/material/styles'

export const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  transition: 'transform 0.3s ease',
  '&:hover': {
    background: theme.palette.background.default,
    transform: 'scale(0.99)',
  },
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
}))

export const StyledIconButton = styled(IconButton)({
  width: 16,
  height: 16,
})

export const PopupContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  borderRadius: theme.shape.customBorderRadius.large,
  backgroundColor: theme.palette.primary.main,
  '& button:not(:last-child)': {
    marginRight: 12,
  },
}))
